//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import HowItWorks from '~/components/common/HowItWork.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    HowItWorks
  },
  head () {
    return {
      title: this.$t('footer.products-services.voucher').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  data () {
    return {
      hiw: {
        title: 'voucher.block3.title',
        subtitle: 'voucher.block3.text1',
        steps: [
          'voucher.block3.item1',
          'voucher.block3.item2',
          'voucher.block3.item3',
          'voucher.block3.item4'
        ],
        imgs: [
          require('@/assets/img/products-services/voucher-payment/b3-1.png'),
          require('@/assets/img/products-services/voucher-payment/b3-2.png'),
          require('@/assets/img/products-services/voucher-payment/b3-3.png'),
          require('@/assets/img/products-services/voucher-payment/b3-4.png')
        ]
      }
    }
  }
}
